<template>
  <main class="events-page">
    <HeroSection />
    <EventsFilters />
    <div class="events-results">
      <div
        v-if="loading"
        class="loader"
      >
        <SpinnerIcon />
      </div>
      <div
        v-else-if="!loading && !libraryEvents.length && !upcomingEvents.length"
        class="container"
      >
        <h4 class="no-results">No results</h4>
      </div>
      <template v-else>
        <UpcomingSection
          v-if="upcomingEvents.length"
          :upcoming-events="upcomingEvents"
          :has-library-events="libraryEvents.length > 0"
        />
        <LibrarySection
          v-if="libraryEvents.length"
          :library-events="libraryEvents"
          :has-upcoming-events="upcomingEvents.length > 0"
        />
      </template>
    </div>
  </main>
</template>

<script>
import EventsFilters from './EventsFilters/EventsFilters.vue';
import HeroSection from './HeroSection/HeroSection.vue';
import UpcomingSection from './UpcomingSection/UpcomingSection.vue';
import LibrarySection from './LibrarySection/LibrarySection.vue';
import SpinnerIcon from '~/components/Common/Svg/SpinnerIcon.vue';
import { useEventsStore } from '~/stores/events';

export default {
  components: {
    HeroSection,
    EventsFilters,
    UpcomingSection,
    LibrarySection,
    SpinnerIcon,
  },
  data() {
    return {
      loading: false,
      eventsStore: useEventsStore(),
    };
  },
  computed: {
    libraryEvents() {
      return this.eventsStore.libraryEvents;
    },
    upcomingEvents() {
      return this.eventsStore.upcomingEvents;
    },
    tag() {
      return this.eventsStore.tag;
    },
    date() {
      return this.eventsStore.date;
    },
    tagDate() {
      return `${this.tag}|${this.date}`;
    },
  },
  watch: {
    async tagDate(value, oldValue) {
      if (!this.eventsStore || oldValue === 'undefined|undefined') {
        return;
      }

      await this.getEvents();
    },
  },
  methods: {
    async getEvents() {
      try {
        this.loading = true;
        this.eventsStore.resetEvents();
        const upcomingEvents = await this.$cmsApi.get(
          '/events/upcoming',
          this.eventsStore.filterParams
        );
        this.eventsStore.setUpcomingEvents(upcomingEvents);

        const libraryEvents = await this.$cmsApi.get('/events/library', {
          ...this.eventsStore.filterParams,
          ...this.eventsStore.paginationParams,
        });
        this.eventsStore.setLibraryEvents(libraryEvents);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './EventsPage.scss';
</style>
